import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  async submit(event) {
    event.preventDefault()

    const button = event.currentTarget
    const originalHTML = button.innerHTML

    // Disable button and show loading state
    button.disabled = true
    button.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Submitting...'

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Show success message and reload page
        alert(data.message)
        window.location.reload()
      } else {
        // Show error message and restore button
        alert(data.message || 'Failed to submit tax organizer')
        button.disabled = false
        button.innerHTML = originalHTML
      }
    } catch (error) {
      console.error('Error submitting tax organizer:', error)
      alert('An error occurred while submitting the tax organizer')
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }
}
